<span class="error" >
    <ng-content></ng-content>
</span>